import api from "./api";

class TagsManager {

    tags(config?: any) {
        return api.get(`/tags`, config)
    }

    tag(tag_id: string | number, params = {}) {
        return api.get(`/tags/${tag_id}/`, { params })
    }

    retrieve = this.tag
    list = this.tags
}

const tagsManager = new TagsManager()

export default tagsManager
